import { createSelector } from 'reselect';
export var moduleSelector = function moduleSelector(state) {
  return state.module;
};
export var translationMissingSelector = createSelector(moduleSelector, function (state) {
  return state.translationMissing;
});
export var currentStackSelector = createSelector(moduleSelector, function (module) {
  var _module$settings;
  return module === null || module === void 0 ? void 0 : (_module$settings = module.settings) === null || _module$settings === void 0 ? void 0 : _module$settings.stack;
});
export var settingsByStackSelector = function settingsByStackSelector(stack) {
  return createSelector(moduleSelector, function (module) {
    return module.stacks[stack];
  });
};
export default {
  translationMissingSelector: translationMissingSelector,
  currentStackSelector: currentStackSelector,
  moduleSelector: moduleSelector,
  settingsByStackSelector: settingsByStackSelector
};